"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buffer = buffer;
exports.hasArea = hasArea;
exports.scale = scale;
exports.toSize = toSize;

/**
 * @module ol/size
 */

/**
 * An array of numbers representing a size: `[width, height]`.
 * @typedef {Array<number>} Size
 * @api
 */

/**
 * Returns a buffered size.
 * @param {Size} size Size.
 * @param {number} num The amount by which to buffer.
 * @param {Size} [opt_size] Optional reusable size array.
 * @return {Size} The buffered size.
 */
function buffer(size, num, opt_size) {
  if (opt_size === undefined) {
    opt_size = [0, 0];
  }

  opt_size[0] = size[0] + 2 * num;
  opt_size[1] = size[1] + 2 * num;
  return opt_size;
}
/**
 * Determines if a size has a positive area.
 * @param {Size} size The size to test.
 * @return {boolean} The size has a positive area.
 */


function hasArea(size) {
  return size[0] > 0 && size[1] > 0;
}
/**
 * Returns a size scaled by a ratio. The result will be an array of integers.
 * @param {Size} size Size.
 * @param {number} ratio Ratio.
 * @param {Size} [opt_size] Optional reusable size array.
 * @return {Size} The scaled size.
 */


function scale(size, ratio, opt_size) {
  if (opt_size === undefined) {
    opt_size = [0, 0];
  }

  opt_size[0] = size[0] * ratio + 0.5 | 0;
  opt_size[1] = size[1] * ratio + 0.5 | 0;
  return opt_size;
}
/**
 * Returns an `Size` array for the passed in number (meaning: square) or
 * `Size` array.
 * (meaning: non-square),
 * @param {number|Size} size Width and height.
 * @param {Size} [opt_size] Optional reusable size array.
 * @return {Size} Size.
 * @api
 */


function toSize(size, opt_size) {
  if (Array.isArray(size)) {
    return size;
  } else {
    if (opt_size === undefined) {
      opt_size = [size, size];
    } else {
      opt_size[0] = size;
      opt_size[1] = size;
    }

    return opt_size;
  }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7OztBQUFBOzs7O0FBSUE7Ozs7OztBQU1BOzs7Ozs7O0FBT00sU0FBVUEsTUFBVixDQUFpQkMsSUFBakIsRUFBdUJDLEdBQXZCLEVBQTRCQyxRQUE1QixFQUFvQztFQUN4QyxJQUFJQSxRQUFRLEtBQUtDLFNBQWpCLEVBQTRCO0lBQzFCRCxRQUFRLEdBQUcsQ0FBQyxDQUFELEVBQUksQ0FBSixDQUFYO0VBQ0Q7O0VBQ0RBLFFBQVEsQ0FBQyxDQUFELENBQVIsR0FBY0YsSUFBSSxDQUFDLENBQUQsQ0FBSixHQUFVLElBQUlDLEdBQTVCO0VBQ0FDLFFBQVEsQ0FBQyxDQUFELENBQVIsR0FBY0YsSUFBSSxDQUFDLENBQUQsQ0FBSixHQUFVLElBQUlDLEdBQTVCO0VBQ0EsT0FBT0MsUUFBUDtBQUNEO0FBRUQ7Ozs7Ozs7QUFLTSxTQUFVRSxPQUFWLENBQWtCSixJQUFsQixFQUFzQjtFQUMxQixPQUFPQSxJQUFJLENBQUMsQ0FBRCxDQUFKLEdBQVUsQ0FBVixJQUFlQSxJQUFJLENBQUMsQ0FBRCxDQUFKLEdBQVUsQ0FBaEM7QUFDRDtBQUVEOzs7Ozs7Ozs7QUFPTSxTQUFVSyxLQUFWLENBQWdCTCxJQUFoQixFQUFzQk0sS0FBdEIsRUFBNkJKLFFBQTdCLEVBQXFDO0VBQ3pDLElBQUlBLFFBQVEsS0FBS0MsU0FBakIsRUFBNEI7SUFDMUJELFFBQVEsR0FBRyxDQUFDLENBQUQsRUFBSSxDQUFKLENBQVg7RUFDRDs7RUFDREEsUUFBUSxDQUFDLENBQUQsQ0FBUixHQUFlRixJQUFJLENBQUMsQ0FBRCxDQUFKLEdBQVVNLEtBQVYsR0FBa0IsR0FBbkIsR0FBMEIsQ0FBeEM7RUFDQUosUUFBUSxDQUFDLENBQUQsQ0FBUixHQUFlRixJQUFJLENBQUMsQ0FBRCxDQUFKLEdBQVVNLEtBQVYsR0FBa0IsR0FBbkIsR0FBMEIsQ0FBeEM7RUFDQSxPQUFPSixRQUFQO0FBQ0Q7QUFFRDs7Ozs7Ozs7Ozs7QUFTTSxTQUFVSyxNQUFWLENBQWlCUCxJQUFqQixFQUF1QkUsUUFBdkIsRUFBK0I7RUFDbkMsSUFBSU0sS0FBSyxDQUFDQyxPQUFOLENBQWNULElBQWQsQ0FBSixFQUF5QjtJQUN2QixPQUFPQSxJQUFQO0VBQ0QsQ0FGRCxNQUVPO0lBQ0wsSUFBSUUsUUFBUSxLQUFLQyxTQUFqQixFQUE0QjtNQUMxQkQsUUFBUSxHQUFHLENBQUNGLElBQUQsRUFBT0EsSUFBUCxDQUFYO0lBQ0QsQ0FGRCxNQUVPO01BQ0xFLFFBQVEsQ0FBQyxDQUFELENBQVIsR0FBY0YsSUFBZDtNQUNBRSxRQUFRLENBQUMsQ0FBRCxDQUFSLEdBQWNGLElBQWQ7SUFDRDs7SUFDRCxPQUFPRSxRQUFQO0VBQ0Q7QUFDRiIsIm5hbWVzIjpbImJ1ZmZlciIsInNpemUiLCJudW0iLCJvcHRfc2l6ZSIsInVuZGVmaW5lZCIsImhhc0FyZWEiLCJzY2FsZSIsInJhdGlvIiwidG9TaXplIiwiQXJyYXkiLCJpc0FycmF5Il0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInNyYy9zaXplLmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19